import React, { useContext } from 'react'
import get from 'lodash/fp/get'
import Dropdown from 'react-bootstrap/Dropdown'
import { useHistory, Link } from 'react-router-dom'

import AppContext from '../../context'
import { Avatar } from '../Avatar'
import { salmon } from '../../styles/themeColors'

import { UserOptionsNav } from './style'

export const UserOptions: React.FC = () => {
  const history = useHistory()
  const { state, auth } = useContext(AppContext)
  const firstName = get('currentUser.firstName', state)
  const lastName = get('currentUser.lastName', state)

  const handleLogout = () => {
    auth.signOut()
    history.push('/')
  }

  return (
    <UserOptionsNav>
      <Dropdown>
        <Dropdown.Toggle
          id="dropdown-manage-profile"
          variant="outline-primary"
          className="line-1"
        >
          <Avatar
            size="22x22"
            defaultSize={22}
            defaultColor={salmon}
            className="mr-1 rounded-circle"
          />
          {firstName} {lastName}
        </Dropdown.Toggle>

        <Dropdown.Menu id="dropdown-manage-profile-body">
          <Dropdown.Item as={Link} to="/manage-profile">
            Manage profile
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </UserOptionsNav>
  )
}
